<template>
  <div class="playerReportCard">
    <div id="desktop" class="table-responsive">
      <b-tabs content-class="mt-3" class="tabsConent">
        <b-tab :title="'Round ' + i " v-for="(i, index) in range(1, roundsPlayed)"
          :key="index"
          variant="primary"
          class="roundBtnColour"
          title-item-class="scorecardTabs"
          @click="ShowRound(index)" active>
        </b-tab>
      </b-tabs>
      <table id="scoreCard">
        <thead>
          <tr class="t3">
            <th>
              Hole
            </th>
            <th>
              1
            </th>
            <th>
              2
            </th>
            <th>
              3
            </th>
            <th>
              4
            </th>
            <th>
              5
            </th>
            <th>
              6
            </th>
            <th>
              7
            </th>
            <th>
              8
            </th>
            <th>
              9
            </th>
            <th>
              OUT
            </th>
            <th>
              10
            </th>
            <th>
              11
            </th>
            <th>
              12
            </th>
            <th>
              13
            </th>
            <th>
              14
            </th>
            <th>
              15
            </th>
            <th>
              16
            </th>
            <th>
              17
            </th>
            <th>
              18
            </th>
            <th>
              IN
            </th>
            <th>
              TOTAL
            </th>
          </tr>
        </thead>
        <tbody >
          <template v-if="data.multi_course == 'Y'">
            <tr
              class="t3"
              :class="multi.course_X_colour + 'row'"
              v-for="(multi, index) in data.courses.courses_entry"
              :key="index"
            >
              <td>{{ multi.course_X_id }} Mtrs</td>
              <td
                v-for="(meter, index) in multi.course_X_length_meters
                  .split(',')
                  .slice(0, 9)"
                :key="index + Math.random()"
              >
                {{ meter }}
              </td>
              <td>
                {{ multi.course_X_out_length.slice(1, 6) }}
              </td>
              <td
                v-for="(meter, index) in multi.course_X_length_meters
                  .split(',')
                  .slice(9, 18)"
                :key="index + Math.random()"
              >
                {{ meter }}
              </td>
              <td>
                {{ multi.course_X_in_length.slice(1, 6) }}
              </td>
              <td>
                {{ multi.course_X_total_length.slice(1, 6) }}
              </td>
            </tr>
            <tr
              class="t3"
              :class="multi.course_X_colour + 'row'"
              v-for="(multi, index) in data.courses.courses_entry"
              :key="index"
            >
              <td>{{ multi.course_X_id }} Par</td>
              <td
                v-for="(par, index) in multi.course_X_par.split(',').slice(0, 9)"
                :key="index + Math.random()"
              >
                {{ par }}
              </td>
              <td>
                {{ multi.course_X_out_par.slice(1, 6) }}
              </td>
              <td
                v-for="(par, index) in multi.course_X_par.split(',').slice(9, 18)"
                :key="index + Math.random()"
              >
                {{ par }}
              </td>
              <td>
                {{ multi.course_X_in_par.slice(1, 6) }}
              </td>
              <td>
                {{ multi.course_X_total_par }}
              </td>
            </tr>
          </template>
          <template v-else>
            <tr class="t3" >
              <td>
                Yds
              </td>
              <td
                v-for="(yard, index) in data.course_length_yards
                  .split(',')
                  .slice(0, 9)"
                :key="index + Math.random()"
              >
                {{ yard }}
              </td>
              <td>
                {{ data.course_out_length.slice(1, 6) }}
              </td>
              <td
                v-for="(number, index) in data.course_length_yards
                  .split(',')
                  .slice(9, 18)"
                :key="index + Math.random()"
              >
                {{ number }}
              </td>
              <td>
                {{ data.course_in_length.slice(1, 6) }}
              </td>
              <td>
                {{ data.course_total_length.slice(1, 6) }}
              </td>
            </tr>
            <tr class="t3">
              <td>
                Par
              </td>
              <td
                v-for="(yard, index) in data.course_par.split(',').slice(0, 9)"
                :key="index + Math.random()"
              >
                {{ yard }}
              </td>
              <td>
                {{ data.course_out_par.slice(1, 6) }}
              </td>
              <td
                v-for="(number, index) in data.course_par.split(',').slice(9, 18)"
                :key="index + Math.random()"
              >
                {{ number }}
              </td>
              <td>
                {{ data.course_in_par.slice(1, 6) }}
              </td>
              <td>
                {{ data.course_total_par }}
              </td>
            </tr>
          </template>
          <template>
            <template v-if="data.bball_team == 'Y'">
              <tr>
                <td>
                  <a :href="'/player-profiles/' + playerData.external_ref" target="_blank" class="playerLinkPartner">{{playerData.surname}}</a>
                </td>
                <td
                  v-for="(r1, index) in playerData['net_hole_scores_R' + roundsPlayed].split(',').slice(0, 9)"
                  :key="index + Math.random()"
                >
                  <span
                    class="twoUnder"
                    v-if="playerData['net_hole_vspars_R' + roundsPlayed].split(',')[index] == -2"
                  >
                    {{ r1 }}
                  </span>
                  <span
                    class="oneUnder"
                    v-else-if="playerData['net_hole_vspars_R' + roundsPlayed].split(',')[index] == -1"
                  >
                    {{ r1 }}
                  </span>
                  <span
                    class="oneOver"
                    v-else-if="playerData['net_hole_vspars_R' + roundsPlayed].split(',')[index] == 1"
                  >
                    {{ r1 }}
                  </span>
                  <span
                    class="
                    "
                    v-else-if="playerData['net_hole_vspars_R' + roundsPlayed].split(',')[index] == 2"
                  >
                    {{ r1 }}
                  </span>
                  <span v-else>
                    {{ r1 }}
                  </span>
                </td>
                <td>{{ outVal(playerData['net_hole_scores_R' + roundsPlayed]) }}</td>
                <td
                  v-for="(r1, index) in playerData['net_hole_scores_R' + roundsPlayed].split(',').slice(9, 18)"
                  :key="index + Math.random()"
                >
                  <span
                    class="twoUnder"
                    v-if="playerData['net_hole_vspars_R' + roundsPlayed].split(',').slice(9, 18)[index] == -2"
                  >
                    {{ r1 }}
                  </span>
                  <span
                    class="oneUnder"
                    v-else-if="playerData['net_hole_vspars_R' + roundsPlayed].split(',').slice(9, 18)[index] == -1"
                  >
                    {{ r1 }}
                  </span>
                  <span
                    class="oneOver"
                    v-else-if="playerData['net_hole_vspars_R' + roundsPlayed].split(',').slice(9, 18)[index] == 1"
                  >
                    {{ r1 }}
                  </span>
                  <span
                    class="twoOver"
                    v-else-if="playerData['net_hole_vspars_R' + roundsPlayed].split(',')[index] == 2"
                  >
                    {{ r1 }}
                  </span>
                  <span v-else>
                    {{ r1 }}
                  </span>
                </td>
                <td>{{ inVal(playerData['net_hole_scores_R' + roundsPlayed]) }}</td>
                <td>{{ totalVal(playerData['net_hole_scores_R' + roundsPlayed])}}</td>
              </tr>
              <tr>
                <td>
                  <a :href="'/player-profiles/' + playerData.partner_ref_1" target="_blank" class="playerLinkPartner">{{playerData.partner_surname_1}}</a>
                </td>
                <td
                  v-for="(r1, index) in playerData['net_hole_scores_partner_1_R' + roundsPlayed].split(',').slice(0, 9)"
                  :key="index + Math.random()"
                >
                  <span
                    class="twoUnder"
                    v-if="playerData['net_hole_vspars_partner_1_R' + roundsPlayed].split(',')[index] == -2"
                  >
                    {{ r1 }}
                  </span>
                  <span
                    class="oneUnder"
                    v-else-if="playerData['net_hole_vspars_partner_1_R' + roundsPlayed].split(',')[index] == -1"
                  >
                    {{ r1 }}
                  </span>
                  <span
                    class="oneOver"
                    v-else-if="playerData['net_hole_vspars_partner_1_R' + roundsPlayed].split(',')[index] == 1"
                  >
                    {{ r1 }}
                  </span>
                  <span
                    class="
                    "
                    v-else-if="playerData['net_hole_vspars_partner_1_R' + roundsPlayed].split(',')[index] == 2"
                  >
                    {{ r1 }}
                  </span>
                  <span v-else>
                    {{ r1 }}
                  </span>
                </td>
                <td>{{ outVal(playerData['net_hole_scores_partner_1_R' + roundsPlayed]) }}</td>
                <td
                  v-for="(r1, index) in playerData['net_hole_scores_partner_1_R' + roundsPlayed].split(',').slice(9, 18)"
                  :key="index + Math.random()"
                >
                  <span
                    class="twoUnder"
                    v-if="playerData['net_hole_vspars_partner_1_R' + roundsPlayed].split(',').slice(9, 18)[index] == -2"
                  >
                    {{ r1 }}
                  </span>
                  <span
                    class="oneUnder"
                    v-else-if="playerData['net_hole_vspars_partner_1_R' + roundsPlayed].split(',').slice(9, 18)[index] == -1"
                  >
                    {{ r1 }}
                  </span>
                  <span
                    class="oneOver"
                    v-else-if="playerData['net_hole_vspars_partner_1_R' + roundsPlayed].split(',').slice(9, 18)[index] == 1"
                  >
                    {{ r1 }}
                  </span>
                  <span
                    class="twoOver"
                    v-else-if="playerData['net_hole_vspars_partner_1_R' + roundsPlayed].split(',')[index] == 2"
                  >
                    {{ r1 }}
                  </span>
                  <span v-else>
                    {{ r1 }}
                  </span>
                </td>
                <td>{{ inVal(playerData['net_hole_scores_partner_1_R' + roundsPlayed]) }}</td>
                <td>{{ totalVal(playerData['net_hole_scores_partner_1_R' + roundsPlayed])}}</td>
              </tr>
              <tr>
                <td>
                  <a :href="'/player-profiles/' + playerData.partner_ref_2" target="_blank" class="playerLinkPartner" >{{playerData.partner_surname_2}}</a>
                </td>
                <td
                  v-for="(r1, index) in playerData['net_hole_scores_partner_2_R' + roundsPlayed].split(',').slice(0, 9)"
                  :key="index + Math.random()"
                >
                  <span
                    class="twoUnder"
                    v-if="playerData['net_hole_vspars_partner_2_R' + roundsPlayed].split(',')[index] == -2"
                  >
                    {{ r1 }}
                  </span>
                  <span
                    class="oneUnder"
                    v-else-if="playerData['net_hole_vspars_partner_2_R' + roundsPlayed].split(',')[index] == -1"
                  >
                    {{ r1 }}
                  </span>
                  <span
                    class="oneOver"
                    v-else-if="playerData['net_hole_vspars_partner_2_R' + roundsPlayed].split(',')[index] == 1"
                  >
                    {{ r1 }}
                  </span>
                  <span
                    class="
                    "
                    v-else-if="playerData['net_hole_vspars_partner_2_R' + roundsPlayed].split(',')[index] == 2"
                  >
                    {{ r1 }}
                  </span>
                  <span v-else>
                    {{ r1 }}
                  </span>
                </td>
                <td>{{ outVal(playerData['net_hole_scores_partner_2_R' + roundsPlayed]) }}</td>
                <td
                  v-for="(r1, index) in playerData['net_hole_scores_partner_2_R' + roundsPlayed].split(',').slice(9, 18)"
                  :key="index + Math.random()"
                >
                  <span
                    class="twoUnder"
                    v-if="playerData['net_hole_vspars_partner_2_R' + roundsPlayed].split(',').slice(9, 18)[index] == -2"
                  >
                    {{ r1 }}
                  </span>
                  <span
                    class="oneUnder"
                    v-else-if="playerData['net_hole_vspars_partner_2_R' + roundsPlayed].split(',').slice(9, 18)[index] == -1"
                  >
                    {{ r1 }}
                  </span>
                  <span
                    class="oneOver"
                    v-else-if="playerData['net_hole_vspars_partner_2_R' + roundsPlayed].split(',').slice(9, 18)[index] == 1"
                  >
                    {{ r1 }}
                  </span>
                  <span
                    class="twoOver"
                    v-else-if="playerData['net_hole_vspars_partner_2_R' + roundsPlayed].split(',')[index] == 2"
                  >
                    {{ r1 }}
                  </span>
                  <span v-else>
                    {{ r1 }}
                  </span>
                </td>
                <td>{{ inVal(playerData['net_hole_scores_partner_2_R' + roundsPlayed]) }}</td>
                <td>{{ totalVal(playerData['net_hole_scores_partner_2_R' + roundsPlayed])}}</td>
              </tr>
              <tr>
                <td>
                  <a :href="'/player-profiles/' + playerData.partner_ref_3" target="_blank" class="playerLinkPartner">{{playerData.partner_surname_3}}</a>
                </td>
                <td
                  v-for="(r1, index) in playerData['net_hole_scores_partner_3_R' + roundsPlayed].split(',').slice(0, 9)"
                  :key="index + Math.random()"
                >
                  <span
                    class="twoUnder"
                    v-if="playerData['net_hole_vspars_partner_3_R' + roundsPlayed].split(',')[index] == -2"
                  >
                    {{ r1 }}
                  </span>
                  <span
                    class="oneUnder"
                    v-else-if="playerData['net_hole_vspars_partner_3_R' + roundsPlayed].split(',')[index] == -1"
                  >
                    {{ r1 }}
                  </span>
                  <span
                    class="oneOver"
                    v-else-if="playerData['net_hole_vspars_partner_3_R' + roundsPlayed].split(',')[index] == 1"
                  >
                    {{ r1 }}
                  </span>
                  <span
                    class="
                    "
                    v-else-if="playerData['net_hole_vspars_partner_3_R' + roundsPlayed].split(',')[index] == 2"
                  >
                    {{ r1 }}
                  </span>
                  <span v-else>
                    {{ r1 }}
                  </span>
                </td>
                <td>{{ outVal(playerData['net_hole_scores_partner_3_R' + roundsPlayed]) }}</td>
                <td
                  v-for="(r1, index) in playerData['net_hole_scores_partner_3_R' + roundsPlayed].split(',').slice(9, 18)"
                  :key="index + Math.random()"
                >
                  <span
                    class="twoUnder"
                    v-if="playerData['net_hole_vspars_partner_3_R' + roundsPlayed].split(',').slice(9, 18)[index] == -2"
                  >
                    {{ r1 }}
                  </span>
                  <span
                    class="oneUnder"
                    v-else-if="playerData['net_hole_vspars_partner_3_R' + roundsPlayed].split(',').slice(9, 18)[index] == -1"
                  >
                    {{ r1 }}
                  </span>
                  <span
                    class="oneOver"
                    v-else-if="playerData['net_hole_vspars_partner_3_R' + roundsPlayed].split(',').slice(9, 18)[index] == 1"
                  >
                    {{ r1 }}
                  </span>
                  <span
                    class="twoOver"
                    v-else-if="playerData['net_hole_vspars_partner_3_R' + roundsPlayed].split(',')[index] == 2"
                  >
                    {{ r1 }}
                  </span>
                  <span v-else>
                    {{ r1 }}
                  </span>
                </td>
                <td>{{ inVal(playerData['net_hole_scores_partner_3_R' + roundsPlayed]) }}</td>
                <td>{{ totalVal(playerData['net_hole_scores_partner_3_R' + roundsPlayed])}}</td>
              </tr>
              <tr class="TeamRow">
                <td>Team</td>
                <td
                  v-for="(r1, index) in playerData['team_hole_vspars_R' + roundsPlayed].split(',').slice(0, 9)"
                  :key="index + Math.random()"
                >
                  <span
                    class="twoUnder"
                    v-if="playerData['team_hole_vspars_R' + roundsPlayed].split(',')[index] == -2"
                  >
                    {{ r1 }}
                  </span>
                  <span
                    class="threeUnder"
                    v-if="playerData['team_hole_vspars_R' + roundsPlayed].split(',')[index] == -3"
                  >
                    {{ r1 }}
                  </span>
                  <span
                    class="threeUnder"
                    v-if="playerData['team_hole_vspars_R' + roundsPlayed].split(',')[index] == -4"
                  >
                    {{ r1 }}
                  </span>
                  <span
                    class="oneUnder"
                    v-else-if="playerData['team_hole_vspars_R' + roundsPlayed].split(',')[index] == -1"
                  >
                    {{ r1 }}
                  </span>
                  <span
                    class="oneOver"
                    v-else-if="playerData['team_hole_vspars_R' + roundsPlayed].split(',')[index] == 1"
                  >
                    {{ r1 }}
                  </span>
                  <span
                    class="fourOver"
                    v-else-if="playerData['team_hole_vspars_R' + roundsPlayed].split(',')[index] == 4"
                  >
                    {{ r1 }}
                  </span>
                  <span
                    class="sixOver"
                    v-else-if="playerData['team_hole_vspars_R' + roundsPlayed].split(',')[index] == 6"
                  >
                    {{ r1 }}
                  </span>
                  <span
                    class="fiveOver"
                    v-else-if="playerData['team_hole_vspars_R' + roundsPlayed].split(',')[index] == 5"
                  >
                    {{ r1 }}
                  </span>
                  <span
                    class="
                    "
                    v-else-if="playerData['team_hole_vspars_R' + roundsPlayed].split(',')[index] == 2"
                  >
                    {{ r1 }}
                  </span>
                  <span v-else>
                    <span v-if="r1 == '0'">Par</span>
                  </span>
                </td>
                <td>{{ outVal(playerData['team_hole_vspars_R' + roundsPlayed]) }}</td>
                <td
                  v-for="(r1, index) in playerData['team_hole_vspars_R' + roundsPlayed].split(',').slice(9, 18)"
                  :key="index + Math.random()"
                >
                  <span
                    class="twoUnder"
                    v-if="playerData['team_hole_vspars_R' + roundsPlayed].split(',').slice(9, 18)[index] == -2"
                  >
                    {{ r1 }}
                  </span>
                  <span
                    class="threeUnder"
                    v-if="playerData['team_hole_vspars_R' + roundsPlayed].split(',').slice(9, 18)[index] == -3"
                  >
                    {{ r1 }}
                  </span>
                  <span
                    class="fourUnder"
                    v-if="playerData['team_hole_vspars_R' + roundsPlayed].split(',').slice(9, 18)[index] == -4"
                  >
                    {{ r1 }}
                  </span>
                  <span
                    class="oneUnder"
                    v-else-if="playerData['team_hole_vspars_R' + roundsPlayed].split(',').slice(9, 18)[index] == -1"
                  >
                    {{ r1 }}
                  </span>
                  <span
                    class="oneOver"
                    v-else-if="playerData['team_hole_vspars_R' + roundsPlayed].split(',').slice(9, 18)[index] == 1"
                  >
                    {{ r1 }}
                  </span>
                  <span
                    class="twoOver"
                    v-else-if="playerData['team_hole_vspars_R' + roundsPlayed].split(',')[index] == 2"
                  >
                    {{ r1 }}
                  </span>
                  <span
                    class="threever"
                    v-else-if="playerData['team_hole_vspars_R' + roundsPlayed].split(',')[index] == 3"
                  >
                    {{ r1 }}
                  </span>
                  <span
                    class="fourOver"
                    v-else-if="playerData['team_hole_vspars_R' + roundsPlayed].split(',')[index] == 4"
                  >
                    {{ r1 }}
                  </span>
                  <span
                    class="fiveOver"
                    v-else-if="playerData['team_hole_vspars_R' + roundsPlayed].split(',')[index] == 5"
                  >
                    {{ r1 }}
                  </span>
                  <span
                    class="sixOver"
                    v-else-if="playerData['team_hole_vspars_R' + roundsPlayed].split(',')[index] == 6"
                  >
                    {{ r1 }}
                  </span>
                  <span v-else>
                    <span v-if="r1 == '0'">Par</span>
                  </span>
                </td>
                <td>{{ inVal(playerData['team_hole_vspars_R' + roundsPlayed]) }}</td>
                <td>{{ totalVal(playerData['team_hole_vspars_R' + roundsPlayed])}}</td>
              </tr>
              <!-- End of partners section -->
            </template>
            <template v-else>
              <template>
                <tr class="RoundColour">
                  <template>
                    <span v-if="playerData['score_R' + buttonRound] == 'RTD' || playerData['score_R' + buttonRound] == 'DSQ' || playerData['score_R' + buttonRound] == 'WDN'">
                      <td>{{playerData['score_R' + buttonRound]}}</td>
                    </span>
                    <span v-else>
                      <template v-if="data.show_points_gross == 'B' || scoreType == 'P'">
                      <td>Gross <span v-if="data.multi_course == 'Y'" :class="playerData['course_colour_R' + buttonRound]">•</span></td>
                      </template>
                      <template v-else>
                        <td>R{{ buttonRound }} <span v-if="data.multi_course == 'Y'" :class="playerData['course_colour_R' + buttonRound]">•</span></td>
                      </template>
                    </span>
                  </template>
                  <template v-if="data.stableford == 'N' && scoreType == 'G'">
                    <template>
                      <td
                        v-for="(r1, index) in playerData['hole_scores_R' + buttonRound].split(',').slice(0, 9)"
                        :key="index + Math.random()"
                      >
                        <span
                          class="twoUnder"
                          v-if="playerData['hole_vspars_R' + buttonRound].split(',')[index] == -2"
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class="oneUnder"
                          v-else-if="playerData['hole_vspars_R' + buttonRound].split(',')[index] == -1"
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class="oneOver"
                          v-else-if="playerData['hole_vspars_R' + buttonRound].split(',')[index] == 1"
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class="twoOver"
                          v-else-if="playerData['hole_vspars_R' + buttonRound].split(',')[index] == 2"
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class="twoOver"
                          v-else-if="playerData['hole_vspars_R' + buttonRound].split(',')[index] > 2"
                        >
                          {{ r1 }}
                        </span>
                        <span v-else>
                          {{ r1 }}
                        </span>
                      </td>
                      <!-- Out -->
                      <td>
                        <template v-if="(playerData['hole_scores_R' + buttonRound]).split(',').slice(8,9) != ''">
                          {{ outVal(playerData['hole_scores_R' + buttonRound]) }}
                        </template>
                        <template v-else>
                        </template>
                      </td>
                      <!-- End of Out -->
                      <td
                        v-for="(r1, index) in playerData['hole_scores_R' + buttonRound].split(',').slice(9, 18)"

                        :key="index + Math.random()"
                      >
                        <span
                          class="twoUnder"
                          v-if="playerData['hole_vspars_R' + buttonRound].split(',').slice(9, 18)[index] == -2"
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class="oneUnder"
                          v-else-if="playerData['hole_vspars_R' + buttonRound].split(',').slice(9, 18)[index] == -1"
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class="oneOver"
                          v-else-if="playerData['hole_vspars_R' + buttonRound].split(',').slice(9, 18)[index] == 1"
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class="twoOver"
                          v-else-if="playerData['hole_vspars_R' + buttonRound].split(',').slice(9, 18)[index] == 2"
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class="twoOver"
                          v-else-if="playerData['hole_vspars_R' + buttonRound].split(',').slice(9, 18)[index] > 2"
                        >
                          {{ r1 }}
                        </span>
                        <span v-else>
                          {{ r1 }}
                        </span>
                      </td>
                      <!-- In -->
                      <td>
                        <template v-if="(playerData['hole_scores_R' + buttonRound]).split(',').slice(17,18) != ''">
                          {{ inVal(playerData['hole_scores_R' + buttonRound]) }}
                        </template>
                        <template v-else>
                        </template>
                      </td>
                      <!-- End of In -->
                      <!-- Total -->
                      <td>
                        <template v-if="(playerData['hole_scores_R' + buttonRound]).split(',').slice(17,18) != ''">
                          {{ totalVal(playerData['hole_scores_R' + buttonRound])}}
                        </template>
                        <template v-else>
                        </template>
                      </td>
                      <!-- End of Total -->
                    </template>
                  </template>
                  <template v-else-if="data.stableford == 'N' && data.team_net == 'N'">
                    <template>
                      <td
                        v-for="(r1, index) in playerData['team_hole_vspars_R' + buttonRound].split(',').slice(0, 9)"
                        :key="index + Math.random()"
                      >
                        <span
                          class="twoUnder"
                          v-if="playerData['team_hole_vspars_R' + buttonRound].split(',')[index] == -2"
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class="oneUnder"
                          v-else-if="playerData['team_hole_vspars_R' + buttonRound].split(',')[index] == -1"
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class="oneOver"
                          v-else-if="playerData['team_hole_vspars_R' + buttonRound].split(',')[index] == 1"
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class="twoOver"
                          v-else-if="playerData['team_hole_vspars_R' + buttonRound].split(',')[index] == 2"
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class="twoOver"
                          v-else-if="playerData['team_hole_vspars_R' + buttonRound].split(',')[index] > 2"
                        >
                          {{ r1 }}
                        </span>
                        <span v-else>
                          {{ r1 }}
                        </span>
                      </td>
                      <!-- Out -->
                      <td>
                        <template v-if="(playerData['team_hole_vspars_R' + buttonRound]).split(',').slice(8,9) != ''">
                          {{ outVal(playerData['team_hole_vspars_R' + buttonRound]) }}
                        </template>
                        <template v-else>
                        </template>
                      </td>
                      <!-- End of Out -->
                      <td
                        v-for="(r1, index) in playerData['team_hole_vspars_R' + buttonRound].split(',').slice(9, 18)"
                        :key="index + Math.random()"
                      >
                        <span
                          class="twoUnder"
                          v-if="playerData['team_hole_vspars_R' + buttonRound].split(',')[index] == -2"
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class="oneUnder"
                          v-else-if="playerData['team_hole_vspars_R' + buttonRound].split(',')[index] == -1"
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class="oneOver"
                          v-else-if="playerData['team_hole_vspars_R' + buttonRound].split(',')[index] == 1"
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class="twoOver"
                          v-else-if="playerData['team_hole_vspars_R' + buttonRound].split(',')[index] == 2"
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class="twoOver"
                          v-else-if="playerData['team_hole_vspars_R' + buttonRound].split(',')[index] > 2"
                        >
                          {{ r1 }}
                        </span>
                        <span v-else>
                          {{ r1 }}
                        </span>
                      </td>
                      <!-- In -->
                      <td>
                        <template v-if="(playerData['team_hole_vspars_R' + buttonRound]).split(',').slice(17,18) != ''">
                          {{ inVal(playerData['team_hole_vspars_R' + buttonRound]) }}
                        </template>
                        <template v-else>
                        </template>
                      </td>
                      <!-- End of In -->
                      <!-- Total -->
                      <td>
                        <template v-if="(playerData['team_hole_vspars_R' + buttonRound]).split(',').slice(17,18) != ''">
                          {{ totalVal(playerData['team_hole_vspars_R' + buttonRound])}}
                        </template>
                        <template v-else>
                        </template>
                      </td>
                      <!-- End of Total -->
                    </template>
                  </template>
                  <template v-else-if="data.stableford == 'N' && data.team_net == 'Y'">
                    <template>
                      <td
                        v-for="(r1, index) in playerData['team_hole_scores_R' + buttonRound].split(',').slice(0, 9)"
                        :key="index + Math.random()"
                      >
                        <span
                          class="twoUnder"
                          v-if="playerData['team_hole_vspars_R' + buttonRound].split(',')[index] == -2"
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class="oneUnder"
                          v-else-if="playerData['team_hole_vspars_R' + buttonRound].split(',')[index] == -1"
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class="oneOver"
                          v-else-if="playerData['team_hole_vspars_R' + buttonRound].split(',')[index] == 1"
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class="twoOver"
                          v-else-if="playerData['team_hole_vspars_R' + buttonRound].split(',')[index] == 2"
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class="twoOver"
                          v-else-if="playerData['team_hole_vspars_R' + buttonRound].split(',')[index] > 2"
                        >
                          {{ r1 }}
                        </span>
                        <span v-else>
                          {{ r1 }}
                        </span>
                      </td>
                      <!-- Out -->
                      <td>
                        <template v-if="(playerData['team_hole_scores_R' + buttonRound]).split(',').slice(8,9) != ''">
                          {{ outVal(playerData['team_hole_scores_R' + buttonRound]) }}
                        </template>
                        <template v-else>
                        </template>
                      </td>
                      <!-- End of Out -->
                      <td
                        v-for="(r1, index) in playerData['team_hole_scores_R' + buttonRound].split(',').slice(9, 18)"
                        :key="index + Math.random()"
                      >
                        <span
                          class="twoUnder"
                          v-if="playerData['team_hole_vspars_R' + buttonRound].split(',')[index] == -2"
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class="oneUnder"
                          v-else-if="playerData['team_hole_vspars_R' + buttonRound].split(',')[index] == -1"
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class="oneOver"
                          v-else-if="playerData['team_hole_vspars_R' + buttonRound].split(',')[index] == 1"
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class="twoOver"
                          v-else-if="playerData['team_hole_vspars_R' + buttonRound].split(',')[index] == 2"
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class="twoOver"
                          v-else-if="playerData['team_hole_vspars_R' + buttonRound].split(',')[index] > 2"
                        >
                          {{ r1 }}
                        </span>
                        <span v-else>
                          {{ r1 }}
                        </span>
                      </td>
                      <!-- In -->
                      <td>
                        <template v-if="(playerData['team_hole_scores_R' + buttonRound]).split(',').slice(17,18) != ''">
                          {{ inVal(playerData['team_hole_scores_R' + buttonRound]) }}
                        </template>
                        <template v-else>
                        </template>
                      </td>
                      <!-- End of In -->
                      <!-- Total -->
                      <td>
                        <template v-if="(playerData['team_hole_scores_R' + buttonRound]).split(',').slice(17,18) != ''">
                          {{ totalVal(playerData['team_hole_scores_R' + buttonRound])}}
                        </template>
                        <template v-else>
                        </template>
                      </td>
                      <!-- End of Total -->
                    </template>
                  </template>
                  <template v-else-if="scoreType == 'P' ">
                    <template >
                      <td
                        v-for="(r1, index) in playerData['hole_scores_R' + roundsPlayed].split(',').slice(0, 9)"
                        :key="index + Math.random()"
                      >
                        <span
                          class="twoUnder"
                          v-if="playerData['hole_vspars_R' + roundsPlayed].split(',')[index] == -2"
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class="oneUnder"
                          v-else-if="playerData['hole_vspars_R' + roundsPlayed].split(',')[index] == -1"
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class="oneOver"
                          v-else-if="playerData['hole_vspars_R' + roundsPlayed].split(',')[index] == 1"
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class="twoOver"
                          v-else-if="playerData['hole_vspars_R' + roundsPlayed].split(',')[index] == 2"
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class="twoOver"
                          v-else-if="playerData['hole_vspars_R' + roundsPlayed].split(',')[index] > 2"
                        >
                          {{ r1 }}
                        </span>
                        <span v-else>
                          {{ r1 }}
                        </span>
                      </td>
                      <td>{{ outVal(playerData['hole_scores_R' + roundsPlayed]) }}</td>
                      <td
                        v-for="(r1, index) in playerData['hole_scores_R' + roundsPlayed].split(',').slice(9, 18)"

                        :key="index + Math.random()"
                      >
                        <span
                          class="twoUnder"
                          v-if="playerData['hole_vspars_R' + roundsPlayed].split(',').slice(9, 18)[index] == -2"
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class="oneUnder"
                          v-else-if="playerData['hole_vspars_R' + roundsPlayed].split(',').slice(9, 18)[index] == -1"
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class="oneOver"
                          v-else-if="playerData['hole_vspars_R' + roundsPlayed].split(',').slice(9, 18)[index] == 1"
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class="twoOver"
                          v-else-if="playerData['hole_vspars_R' + roundsPlayed].split(',').slice(9, 18)[index] == 2"
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class="twoOver"
                          v-else-if="playerData['hole_vspars_R' + roundsPlayed].split(',').slice(9, 18)[index] > 2"
                        >
                          {{ r1 }}
                        </span>
                        <span v-else>
                          {{ r1 }}
                        </span>
                      </td>
                      <td>{{ inVal(playerData['hole_scores_R' + roundsPlayed]) }}</td>
                      <td>{{ totalVal(playerData['hole_scores_R' + roundsPlayed])}}</td>
                    </template>
                  </template>
                  <template v-else-if="data.stableford == 'Y' && scoreType == 'G'">
                    <template >
                      <td
                        v-for="(r1, index) in playerDataTeam['hole_points_R' + buttonRound].split(',').slice(0, 9)"
                        :key="index + Math.random()"
                      >
                        <span
                          class=""
                          v-if="playerDataTeam['hole_vspars_R' + buttonRound].split(',')[index] == -2"
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class=""
                          v-else-if="playerDataTeam['hole_vspars_R' + buttonRound].split(',')[index] == -1"
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class=""
                          v-else-if="playerDataTeam['hole_vspars_R' + buttonRound].split(',')[index] == 1"
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class=""
                          v-else-if="playerDataTeam['hole_vspars_R' + buttonRound].split(',')[index] == 2"
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class=""
                          v-else-if="playerDataTeam['hole_vspars_R' + buttonRound].split(',')[index] > 2"
                        >
                          {{ r1 }}
                        </span>
                        <span v-else>
                          {{ r1 }}
                        </span>
                      </td>
                      <td>{{ outVal(playerDataTeam['hole_points_R' + buttonRound]) }}</td>
                      <td
                        v-for="(r1, index) in playerDataTeam['hole_points_R' + buttonRound].split(',').slice(9, 18)"

                        :key="index + Math.random()"
                      >
                        <span
                          class=""
                          v-if="playerDataTeam['hole_vspars_R' + buttonRound].split(',').slice(9, 18)[index] == -2"
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class=""
                          v-else-if="playerDataTeam['hole_vspars_R' + buttonRound].split(',').slice(9, 18)[index] == -1"
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class=""
                          v-else-if="playerDataTeam['hole_vspars_R' + buttonRound].split(',').slice(9, 18)[index] == 1"
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class=""
                          v-else-if="playerDataTeam['hole_vspars_R' + buttonRound].split(',').slice(9, 18)[index] == 2"
                        >
                          {{ r1 }}
                        </span>
                        <span
                          class=""
                          v-else-if="playerDataTeam['hole_vspars_R' + buttonRound].split(',').slice(9, 18)[index] > 2"
                        >
                          {{ r1 }}
                        </span>
                        <span v-else>
                          {{ r1 }}
                        </span>
                      </td>
                      <td>{{ inVal(playerDataTeam['hole_points_R' + buttonRound]) }}</td>
                      <td>{{ totalVal(playerDataTeam['hole_points_R' + buttonRound])}}</td>
                    </template>
                  </template>

                  <template v-else>
                    <template v-if="data.tt_enter_points == 'N'">
                      <template v-if="data.show_points_gross == 'G' || data.show_points_gross == 'B'">
                        <td
                          v-for="(r1, index) in playerData['hole_scores_R' + roundsPlayed].split(',').slice(0, 9)"
                          :key="index + Math.random()"
                        >
                          <span
                            class="twoUnder"
                            v-if="playerData['hole_vspars_R' + roundsPlayed].split(',')[index] == -2"
                          >
                            {{ r1 }}
                          </span>
                          <span
                            class="oneUnder"
                            v-else-if="playerData['hole_vspars_R' + roundsPlayed].split(',')[index] == -1"
                          >
                            {{ r1 }}
                          </span>
                          <span
                            class="oneOver"
                            v-else-if="playerData['hole_vspars_R' + roundsPlayed].split(',')[index] == 1"
                          >
                            {{ r1 }}
                          </span>
                          <span
                            class="twoOver"
                            v-else-if="playerData['hole_vspars_R' + roundsPlayed].split(',')[index] == 2"
                          >
                            {{ r1 }}
                          </span>
                          <span
                            class="twoOver"
                            v-else-if="playerData['hole_vspars_R' + roundsPlayed].split(',')[index] > 2"
                          >
                            {{ r1 }}
                          </span>
                          <span v-else>
                            {{ r1 }}
                          </span>
                        </td>
                        <td>{{ outVal(playerData['hole_scores_R' + roundsPlayed]) }}</td>
                        <td
                          v-for="(r1, index) in playerData['hole_scores_R' + roundsPlayed].split(',').slice(9, 18)"

                          :key="index + Math.random()"
                        >
                          <span
                            class="twoUnder"
                            v-if="playerData['hole_vspars_R' + roundsPlayed].split(',').slice(9, 18)[index] == -2"
                          >
                            {{ r1 }}
                          </span>
                          <span
                            class="oneUnder"
                            v-else-if="playerData['hole_vspars_R' + roundsPlayed].split(',').slice(9, 18)[index] == -1"
                          >
                            {{ r1 }}
                          </span>
                          <span
                            class="oneOver"
                            v-else-if="playerData['hole_vspars_R' + roundsPlayed].split(',').slice(9, 18)[index] == 1"
                          >
                            {{ r1 }}
                          </span>
                          <span
                            class="twoOver"
                            v-else-if="playerData['hole_vspars_R' + roundsPlayed].split(',').slice(9, 18)[index] == 2"
                          >
                            {{ r1 }}
                          </span>
                          <span
                            class="twoOver"
                            v-else-if="playerData['hole_vspars_R' + roundsPlayed].split(',').slice(9, 18)[index] > 2"
                          >
                            {{ r1 }}
                          </span>
                          <span v-else>
                            {{ r1 }}
                          </span>
                        </td>
                        <td>{{ inVal(playerData['hole_scores_R' + roundsPlayed]) }}</td>
                        <td>{{ totalVal(playerData['hole_scores_R' + roundsPlayed])}}</td>
                      </template>
                      <template v-if="data.show_points_gross == 'P'">
                        <td
                          v-for="(r1, index) in playerData['hole_points_R' + roundsPlayed].split(',').slice(0, 9)"
                          :key="index + Math.random()"
                        >
                          <span
                            class="twoUnder"
                            v-if="playerData['hole_vspars_R' + roundsPlayed].split(',')[index] == -2"
                          >
                            {{ r1 }}
                          </span>
                          <span
                            class="oneUnder"
                            v-else-if="playerData['hole_vspars_R' + roundsPlayed].split(',')[index] == -1"
                          >
                            {{ r1 }}
                          </span>
                          <span
                            class="oneOver"
                            v-else-if="playerData['hole_vspars_R' + roundsPlayed].split(',')[index] == 1"
                          >
                            {{ r1 }}
                          </span>
                          <span
                            class="twoOver"
                            v-else-if="playerData['hole_vspars_R' + roundsPlayed].split(',')[index] == 2"
                          >
                            {{ r1 }}
                          </span>
                          <span
                            class="twoOver"
                            v-else-if="playerData['hole_vspars_R' + roundsPlayed].split(',')[index] > 2"
                          >
                            {{ r1 }}
                          </span>
                          <span v-else>
                            {{ r1 }}
                          </span>
                        </td>
                        <td>{{ outVal(playerData['hole_points_R' + roundsPlayed]) }}</td>
                        <td
                          v-for="(r1, index) in playerData['hole_points_R' + roundsPlayed].split(',').slice(9, 18)"

                          :key="index + Math.random()"
                        >
                          <span
                            class="twoUnder"
                            v-if="playerData['hole_vspars_R' + roundsPlayed].split(',').slice(9, 18)[index] == -2"
                          >
                            {{ r1 }}
                          </span>
                          <span
                            class="oneUnder"
                            v-else-if="playerData['hole_vspars_R' + roundsPlayed].split(',').slice(9, 18)[index] == -1"
                          >
                            {{ r1 }}
                          </span>
                          <span
                            class="oneOver"
                            v-else-if="playerData['hole_vspars_R' + roundsPlayed].split(',').slice(9, 18)[index] == 1"
                          >
                            {{ r1 }}
                          </span>
                          <span
                            class="twoOver"
                            v-else-if="playerData['hole_vspars_R' + roundsPlayed].split(',').slice(9, 18)[index] == 2"
                          >
                            {{ r1 }}
                          </span>
                          <span
                            class="twoOver"
                            v-else-if="playerData['hole_vspars_R' + roundsPlayed].split(',').slice(9, 18)[index] > 2"
                          >
                            {{ r1 }}
                          </span>
                          <span v-else>
                            {{ r1 }}
                          </span>
                        </td>
                        <td>{{ inVal(playerData['hole_points_R' + roundsPlayed]) }}</td>
                        <td>{{ totalVal(playerData['hole_points_R' + roundsPlayed])}}</td>
                      </template>
                    </template>
                    <template v-else>
                      <template>
                        <td
                          v-for="(r1, index) in playerData['hole_points_R' + roundsPlayed].split(',').slice(0, 9)"
                          :key="index + Math.random()"
                        >
                          <span
                            class="twoUnder"
                            v-if="playerData['hole_vspars_R' + roundsPlayed].split(',')[index] == -2"
                          >
                            {{ r1 }}
                          </span>
                          <span
                            class="oneUnder"
                            v-else-if="playerData['hole_vspars_R' + roundsPlayed].split(',')[index] == -1"
                          >
                            {{ r1 }}
                          </span>
                          <span
                            class="oneOver"
                            v-else-if="playerData['hole_vspars_R' + roundsPlayed].split(',')[index] == 1"
                          >
                            {{ r1 }}
                          </span>
                          <span
                            class="twoOver"
                            v-else-if="playerData['hole_vspars_R' + roundsPlayed].split(',')[index] == 2"
                          >
                            {{ r1 }}
                          </span>
                          <span
                            class="twoOver"
                            v-else-if="playerData['hole_vspars_R' + roundsPlayed].split(',')[index] > 2"
                          >
                            {{ r1 }}
                          </span>
                          <span v-else>
                            {{ r1 }}
                          </span>
                        </td>
                        <td>{{ outVal(playerData['hole_points_R' + roundsPlayed]) }}</td>
                        <td
                          v-for="(r1, index) in playerData['hole_points_R' + roundsPlayed].split(',').slice(9, 18)"

                          :key="index + Math.random()"
                        >
                          <span
                            class="twoUnder"
                            v-if="playerData['hole_vspars_R' + roundsPlayed].split(',').slice(9, 18)[index] == -2"
                          >
                            {{ r1 }}
                          </span>
                          <span
                            class="oneUnder"
                            v-else-if="playerData['hole_vspars_R' + roundsPlayed].split(',').slice(9, 18)[index] == -1"
                          >
                            {{ r1 }}
                          </span>
                          <span
                            class="oneOver"
                            v-else-if="playerData['hole_vspars_R' + roundsPlayed].split(',').slice(9, 18)[index] == 1"
                          >
                            {{ r1 }}
                          </span>
                          <span
                            class="twoOver"
                            v-else-if="playerData['hole_vspars_R' + roundsPlayed].split(',').slice(9, 18)[index] == 2"
                          >
                            {{ r1 }}
                          </span>
                          <span
                            class="twoOver"
                            v-else-if="playerData['hole_vspars_R' + roundsPlayed].split(',').slice(9, 18)[index] > 2"
                          >
                            {{ r1 }}
                          </span>
                          <span v-else>
                            {{ r1 }}
                          </span>
                        </td>
                        <td>{{ inVal(playerData['hole_points_R' + roundsPlayed]) }}</td>
                        <td>{{ totalVal(playerData['hole_points_R' + roundsPlayed])}}</td>
                      </template>
                    </template>
                  </template>
                </tr>
                <template v-if="scoreType == 'P'">
                  <tr class="RoundColour">
                    <template>
                      <span v-if="playerData['score_R' + buttonRound] == 'RTD' || playerData['score_R' + buttonRound] == 'DSQ' || playerData['score_R' + buttonRound] == 'WDN'">
                        <td>{{playerData['score_R' + buttonRound]}}</td>
                      </span>
                      <span v-else>
                        <td>Points <span v-if="data.multi_course == 'Y'" :class="playerData['course_colour_R' + buttonRound]">•</span></td>
                      </span>
                    </template>
                    <template>
                      <template>
                        <td
                          v-for="(r1, index) in playerData['hole_points_R' + roundsPlayed].split(',').slice(0, 9)"
                          :key="index + Math.random()"
                        >
                          <span
                            class="twoUnder"
                            v-if="playerData['hole_vspars_R' + roundsPlayed].split(',')[index] == -2"
                          >
                            {{ r1 }}
                          </span>
                          <span
                            class="oneUnder"
                            v-else-if="playerData['hole_vspars_R' + roundsPlayed].split(',')[index] == -1"
                          >
                            {{ r1 }}
                          </span>
                          <span
                            class="oneOver"
                            v-else-if="playerData['hole_vspars_R' + roundsPlayed].split(',')[index] == 1"
                          >
                            {{ r1 }}
                          </span>
                          <span
                            class="twoOver"
                            v-else-if="playerData['hole_vspars_R' + roundsPlayed].split(',')[index] == 2"
                          >
                            {{ r1 }}
                          </span>
                          <span
                            class="twoOver"
                            v-else-if="playerData['hole_vspars_R' + roundsPlayed].split(',')[index] > 2"
                          >
                            {{ r1 }}
                          </span>
                          <span v-else>
                            {{ r1 }}
                          </span>
                        </td>
                        <td>{{ outVal(playerData['hole_points_R' + roundsPlayed]) }}</td>
                        <td
                          v-for="(r1, index) in playerData['hole_points_R' + roundsPlayed].split(',').slice(9, 18)"

                          :key="index + Math.random()"
                        >
                          <span
                            class="twoUnder"
                            v-if="playerData['hole_vspars_R' + roundsPlayed].split(',').slice(9, 18)[index] == -2"
                          >
                            {{ r1 }}
                          </span>
                          <span
                            class="oneUnder"
                            v-else-if="playerData['hole_vspars_R' + roundsPlayed].split(',').slice(9, 18)[index] == -1"
                          >
                            {{ r1 }}
                          </span>
                          <span
                            class="oneOver"
                            v-else-if="playerData['hole_vspars_R' + roundsPlayed].split(',').slice(9, 18)[index] == 1"
                          >
                            {{ r1 }}
                          </span>
                          <span
                            class="twoOver"
                            v-else-if="playerData['hole_vspars_R' + roundsPlayed].split(',').slice(9, 18)[index] == 2"
                          >
                            {{ r1 }}
                          </span>
                          <span
                            class="twoOver"
                            v-else-if="playerData['hole_vspars_R' + roundsPlayed].split(',').slice(9, 18)[index] > 2"
                          >
                            {{ r1 }}
                          </span>
                          <span v-else>
                            {{ r1 }}
                          </span>
                        </td>
                        <td>{{ inVal(playerData['hole_points_R' + roundsPlayed]) }}</td>
                        <td>{{ totalVal(playerData['hole_points_R' + roundsPlayed])}}</td>
                      </template>
                    </template>
                  </tr>                  
                </template>
                <template v-if="data.tt_enter_points == 'N'">
                  <tr class="RoundColour" v-if="data.show_points_gross == 'B'">
                    <template>
                      <span v-if="playerData['score_R' + buttonRound] == 'RTD' || playerData['score_R' + buttonRound] == 'DSQ' || playerData['score_R' + buttonRound] == 'WDN'">
                        <td>{{playerData['score_R' + buttonRound]}}</td>
                      </span>
                      <span v-else>
                        <td>Points <span v-if="data.multi_course == 'Y'" :class="playerData['course_colour_R' + buttonRound]">•</span></td>
                      </span>
                    </template>
                    <template>
                      <template>
                        <td
                          v-for="(r1, index) in playerData['hole_points_R' + roundsPlayed].split(',').slice(0, 9)"
                          :key="index + Math.random()"
                        >
                          <span
                            class="twoUnder"
                            v-if="playerData['hole_vspars_R' + roundsPlayed].split(',')[index] == -2"
                          >
                            {{ r1 }}
                          </span>
                          <span
                            class="oneUnder"
                            v-else-if="playerData['hole_vspars_R' + roundsPlayed].split(',')[index] == -1"
                          >
                            {{ r1 }}
                          </span>
                          <span
                            class="oneOver"
                            v-else-if="playerData['hole_vspars_R' + roundsPlayed].split(',')[index] == 1"
                          >
                            {{ r1 }}
                          </span>
                          <span
                            class="twoOver"
                            v-else-if="playerData['hole_vspars_R' + roundsPlayed].split(',')[index] == 2"
                          >
                            {{ r1 }}
                          </span>
                          <span
                            class="twoOver"
                            v-else-if="playerData['hole_vspars_R' + roundsPlayed].split(',')[index] > 2"
                          >
                            {{ r1 }}
                          </span>
                          <span v-else>
                            {{ r1 }}
                          </span>
                        </td>
                        <td>{{ outVal(playerData['hole_points_R' + roundsPlayed]) }}</td>
                        <td
                          v-for="(r1, index) in playerData['hole_scores_R' + roundsPlayed].split(',').slice(9, 18)"

                          :key="index + Math.random()"
                        >
                          <span
                            class="twoUnder"
                            v-if="playerData['hole_vspars_R' + roundsPlayed].split(',').slice(9, 18)[index] == -2"
                          >
                            {{ r1 }}
                          </span>
                          <span
                            class="oneUnder"
                            v-else-if="playerData['hole_vspars_R' + roundsPlayed].split(',').slice(9, 18)[index] == -1"
                          >
                            {{ r1 }}
                          </span>
                          <span
                            class="oneOver"
                            v-else-if="playerData['hole_vspars_R' + roundsPlayed].split(',').slice(9, 18)[index] == 1"
                          >
                            {{ r1 }}
                          </span>
                          <span
                            class="twoOver"
                            v-else-if="playerData['hole_vspars_R' + roundsPlayed].split(',').slice(9, 18)[index] == 2"
                          >
                            {{ r1 }}
                          </span>
                          <span
                            class="twoOver"
                            v-else-if="playerData['hole_vspars_R' + roundsPlayed].split(',').slice(9, 18)[index] > 2"
                          >
                            {{ r1 }}
                          </span>
                          <span v-else>
                            {{ r1 }}
                          </span>
                        </td>
                        <td>{{ inVal(playerData['hole_points_R' + roundsPlayed]) }}</td>
                        <td>{{ totalVal(playerData['hole_points_R' + roundsPlayed])}}</td>
                      </template>
                      <template v-if="data.show_points_gross == 'G'">
                        <td
                          v-for="(r1, index) in playerData['hole_scores_R' + roundsPlayed].split(',').slice(0, 9)"
                          :key="index + Math.random()"
                        >
                          <span
                            class="twoUnder"
                            v-if="playerData['hole_vspars_R' + roundsPlayed].split(',')[index] == -2"
                          >
                            {{ r1 }}
                          </span>
                          <span
                            class="oneUnder"
                            v-else-if="playerData['hole_vspars_R' + roundsPlayed].split(',')[index] == -1"
                          >
                            {{ r1 }}
                          </span>
                          <span
                            class="oneOver"
                            v-else-if="playerData['hole_vspars_R' + roundsPlayed].split(',')[index] == 1"
                          >
                            {{ r1 }}
                          </span>
                          <span
                            class="twoOver"
                            v-else-if="playerData['hole_vspars_R' + roundsPlayed].split(',')[index] == 2"
                          >
                            {{ r1 }}
                          </span>
                          <span
                            class="twoOver"
                            v-else-if="playerData['hole_vspars_R' + roundsPlayed].split(',')[index] > 2"
                          >
                            {{ r1 }}
                          </span>
                          <span v-else>
                            {{ r1 }}
                          </span>
                        </td>
                        <td>{{ outVal(playerData['hole_scores_R' + roundsPlayed]) }}</td>
                        <td
                          v-for="(r1, index) in playerData['hole_scores_R' + roundsPlayed].split(',').slice(9, 18)"

                          :key="index + Math.random()"
                        >
                          <span
                            class="twoUnder"
                            v-if="playerData['hole_vspars_R' + roundsPlayed].split(',').slice(9, 18)[index] == -2"
                          >
                            {{ r1 }}
                          </span>
                          <span
                            class="oneUnder"
                            v-else-if="playerData['hole_vspars_R' + roundsPlayed].split(',').slice(9, 18)[index] == -1"
                          >
                            {{ r1 }}
                          </span>
                          <span
                            class="oneOver"
                            v-else-if="playerData['hole_vspars_R' + roundsPlayed].split(',').slice(9, 18)[index] == 1"
                          >
                            {{ r1 }}
                          </span>
                          <span
                            class="twoOver"
                            v-else-if="playerData['hole_vspars_R' + roundsPlayed].split(',').slice(9, 18)[index] == 2"
                          >
                            {{ r1 }}
                          </span>
                          <span
                            class="twoOver"
                            v-else-if="playerData['hole_vspars_R' + roundsPlayed].split(',').slice(9, 18)[index] > 2"
                          >
                            {{ r1 }}
                          </span>
                          <span v-else>
                            {{ r1 }}
                          </span>
                        </td>
                        <td>{{ inVal(playerData['hole_scores_R' + roundsPlayed]) }}</td>
                        <td>{{ totalVal(playerData['hole_scores_R' + roundsPlayed])}}</td>
                      </template>
                    </template>
                  </tr>                  
                </template>
              </template>
            </template>
            <template v-if="playerData['gir_R' + buttonRound] ">
              <tr :key="roundIt1" :class="{removeTR : outVal(playerData['drive_R' + buttonRound]) == 0 && inVal(playerData['drive_R' + buttonRound]) == 0 && totalVal(playerData['drive_R' + buttonRound]) == 0}">
                <td>D/D</td>
                <td
                  v-for="(r1, index) in playerData['drive_R' + buttonRound]
                    .split(',')
                    .slice(0, 9)"
                  :key="index + Math.random()"
                >
                  {{ r1 }}
                </td>
                <td>{{ outVal(playerData['drive_R' + buttonRound]) }}</td>
                <td
                  v-for="(r1, index) in playerData['drive_R' + buttonRound]
                    .split(',')
                    .slice(9, 18)"
                  :key="index + Math.random()"
                >
                  {{ r1 }}
                </td>
                <td>{{ inVal(playerData['drive_R' + buttonRound]) }}</td>
                <td>{{ totalVal(playerData['drive_R' + buttonRound])}}</td>
              </tr>
              <tr :key="roundIt1" :class="{removeTR : outVal(playerData['fairway_R' + buttonRound]) == 0 && inVal(playerData['fairway_R' + buttonRound]) == 0 && totalVal(playerData['fairway_R' + buttonRound]) == 0}">
                <td>F/W</td>
                <td
                  v-for="(r1, index) in playerData['fairway_R' + buttonRound]
                    .split(',')
                    .slice(0, 9)"
                  :key="index + Math.random()"
                >
                  <span v-if="r1 === 'Y' || r1 === 'y'"
                    ><font-awesome-icon class="check" :icon="['fa', 'check']"
                  /></span>
                  <span v-else-if="r1 === 'N' || r1 === 'n'"
                    ><font-awesome-icon class="cross" :icon="['fa', 'times']"
                  /></span>
                  <span v-else-if="r1 === 'L' || r1 === 'l'">
                    <span style="font-weight:bold; color:red;">L</span>  
                  </span>
                  <span v-else-if="r1 === 'R' || r1 === 'r'">
                    <span style="font-weight:bold; color:red;">R</span>  
                  </span>
                  <span v-else>{{ r1 }}</span>
                </td>
                <td>{{ StatoutVal(playerData['fairway_R' + buttonRound], 'front') }}</td>
                <td
                  v-for="(r1, index) in playerData['fairway_R' + buttonRound]
                    .split(',')
                    .slice(9, 18)"
                  :key="index + Math.random()"
                >
                  <span v-if="r1 === 'Y' || r1 === 'y'"
                    ><font-awesome-icon class="check" :icon="['fa', 'check']"
                  /></span>
                  <span v-else-if="r1 === 'N' || r1 === 'n'"
                    ><font-awesome-icon class="cross" :icon="['fa', 'times']"
                  /></span>
                  <span v-else-if="r1 === 'L' || r1 === 'l'">
                    <span style="font-weight:bold; color:red;">L</span>  
                  </span>
                  <span v-else-if="r1 === 'R' || r1 === 'r'">
                    <span style="font-weight:bold; color:red;">R</span>  
                  </span>
                  <span v-else>{{ r1 }}</span>
                </td>
                <td>{{ StatoutVal(playerData['fairway_R' + buttonRound], 'back') }}</td>
                <td>{{ StatoutVal(playerData['fairway_R' + buttonRound], 'total')}}</td>
              </tr>
              <tr :class="{removeTR : outVal(playerData['gir_R' + buttonRound]) == 0 && inVal(playerData['gir_R' + buttonRound]) == 0 && totalVal(playerData['gir_R' + buttonRound]) == 0}">
                <td>GiR</td>
                <td
                  v-for="(r1, index) in playerData['gir_R' + buttonRound]
                    .split(',')
                    .slice(0, 9)"
                  :key="index + Math.random()"
                >
                  <span v-if="r1 === 'Y' || r1 === 'y'"
                    ><font-awesome-icon class="check" :icon="['fa', 'check']"
                  /></span>
                  <span v-else-if="r1 === 'N' || r1 === 'n'"
                    ><font-awesome-icon class="cross" :icon="['fa', 'times']"
                  /></span>
                  <span v-else>{{ r1 }}</span>
                </td>
                <td>{{ StatoutVal(playerData['gir_R' + buttonRound], 'front') }}</td>
                <td
                  v-for="(r1, index) in playerData['gir_R' + buttonRound]
                    .split(',')
                    .slice(9, 18)"
                  :key="index + Math.random()"
                >
                  <span v-if="r1 === 'Y' || r1 === 'y'"
                    ><font-awesome-icon class="check" :icon="['fa', 'check']"
                  /></span>
                  <span v-else-if="r1 === 'N' || r1 === 'n'"
                    ><font-awesome-icon class="cross" :icon="['fa', 'times']"
                  /></span>
                  <span v-else>{{ r1 }}</span>
                </td>
                <td>{{ StatoutVal(playerData['gir_R' + buttonRound], 'back') }}</td>
                <td>{{ StatoutVal(playerData['gir_R' + buttonRound], 'total')}}</td>
              </tr>
              <tr :key="roundIt1" :class="{removeTR : outVal(playerData['sand_R' + buttonRound]) == 0 && inVal(playerData['sand_R' + buttonRound]) == 0 && totalVal(playerData['sand_R' + buttonRound]) == 0}">
                <td>S/S</td>
                <td
                  v-for="(r1, index) in playerData['sand_R' + buttonRound]
                    .split(',')
                    .slice(0, 9)"
                  :key="index + Math.random()"
                >
                  <span v-if="r1 === 'Y' || r1 === 'y'"
                    ><font-awesome-icon class="check" :icon="['fa', 'check']"
                  /></span>
                  <span v-else-if="r1 === 'N' || r1 === 'n'"
                    ><font-awesome-icon class="cross" :icon="['fa', 'times']"
                  /></span>
                  <span v-else>{{ r1 }}</span>
                </td>
                <td>{{ StatoutVal(playerData['sand_R' + buttonRound], 'front') }}</td>
                <td
                  v-for="(r1, index) in playerData['sand_R' + buttonRound]
                    .split(',')
                    .slice(9, 18)"
                  :key="index + Math.random()"
                >
                  <span v-if="r1 === 'Y' || r1 === 'y'"
                    ><font-awesome-icon class="check" :icon="['fa', 'check']"
                  /></span>
                  <span v-else-if="r1 === 'N' || r1 === 'n'"
                    ><font-awesome-icon class="cross" :icon="['fa', 'times']"
                  /></span>
                  <span v-else>{{ r1 }}</span>
                </td>
                <td>{{ StatoutVal(playerData['sand_R' + buttonRound], 'back') }}</td>
                <td>{{ StatoutVal(playerData['sand_R' + buttonRound], 'total')}}</td>
              </tr>
              <tr :key="roundIt1" :class="{removeTR : outVal(playerData['putts_R' + buttonRound]) == 0 && inVal(playerData['putts_R' + buttonRound]) == 0 && totalVal(playerData['putts_R' + buttonRound]) == 0}">
                <td>Putts</td>
                <td
                  v-for="(r1, index) in playerData['putts_R' + buttonRound]
                    .split(',')
                    .slice(0, 9)"
                  :key="index + Math.random()"
                >
                  {{ r1 }}
                </td>
                <td>{{ outVal(playerData['putts_R' + buttonRound]) }}</td>
                <td
                  v-for="(r1, index) in playerData['putts_R' + buttonRound]
                    .split(',')
                    .slice(9, 18)"
                  :key="index + Math.random()"
                >
                  {{ r1 }}
                </td>
                <td>{{ inVal(playerData['putts_R' + buttonRound]) }}</td>
                <td>{{ totalVal(playerData['putts_R' + buttonRound])}}</td>
              </tr>
            </template>
            <template v-else>

            </template>
          </template>
        </tbody>
      </table>
    </div>
    <!-- Strokes Gained Section -->
      <template v-if="data.hide_sg_sc == 'N'">
        <h3 class="strokesGainedTitle" 
          v-if="playerData['sg_total_R' + buttonRound] !== '' ||
          playerData['sg_drive_R' + buttonRound] !== '' ||
          playerData['sg_approach_R' + buttonRound] !== '' ||
          playerData['sg_short_R' + buttonRound] !== '' ||
          playerData['sg_putting_R' + buttonRound] !== ''
        "
        >Strokes Gained</h3>
        <table id="scoreCard" 
          v-if="playerData['sg_total_R' + buttonRound] !== '' ||
          playerData['sg_drive_R' + buttonRound] !== '' ||
          playerData['sg_approach_R' + buttonRound] !== '' ||
          playerData['sg_short_R' + buttonRound] !== '' ||
          playerData['sg_putting_R' + buttonRound] !== ''
        ">
          <thead>
            <tr class="t3">
              <!-- <th class="titleWidth">
                Round
              </th> -->
              <th class="titleWidth">
                Driving
              </th>
              <th class="titleWidth">
                Approach
              </th>
              <th class="titleWidth">
                Short Game
              </th>
              <th class="titleWidth">
                Putting
              </th>
              <th class="titleWidth">
                Total
              </th>
            </tr>
          </thead>
          <tbody >
            <template>
              <!-- <template v-if="team == 'Y' || data.bball_team == 'Y'">
                <tr>
                  <td>
                    <a :href="'/player-profiles/' + playerData.external_ref" target="_blank" class="playerLinkPartner">{{playerData.surname}}</a>
                  </td>
                  <td
                    v-for="(r1, index) in playerData['net_hole_scores_R' + roundsPlayed].split(',').slice(0, 9)"
                    :key="index + Math.random()"
                  >
                    <span
                      class="twoUnder"
                      v-if="playerData['net_hole_vspars_R' + roundsPlayed].split(',')[index] == -2"
                    >
                      {{ r1 }}
                    </span>
                    <span
                      class="oneUnder"
                      v-else-if="playerData['net_hole_vspars_R' + roundsPlayed].split(',')[index] == -1"
                    >
                      {{ r1 }}
                    </span>
                    <span
                      class="oneOver"
                      v-else-if="playerData['net_hole_vspars_R' + roundsPlayed].split(',')[index] == 1"
                    >
                      {{ r1 }}
                    </span>
                    <span
                      class="
                      "
                      v-else-if="playerData['net_hole_vspars_R' + roundsPlayed].split(',')[index] == 2"
                    >
                      {{ r1 }}
                    </span>
                    <span v-else>
                      {{ r1 }}
                    </span>
                  </td>
                  <td>{{ outVal(playerData['net_hole_scores_R' + roundsPlayed]) }}</td>
                  <td
                    v-for="(r1, index) in playerData['net_hole_scores_R' + roundsPlayed].split(',').slice(9, 18)"
                    :key="index + Math.random()"
                  >
                    <span
                      class="twoUnder"
                      v-if="playerData['net_hole_vspars_R' + roundsPlayed].split(',').slice(9, 18)[index] == -2"
                    >
                      {{ r1 }}
                    </span>
                    <span
                      class="oneUnder"
                      v-else-if="playerData['net_hole_vspars_R' + roundsPlayed].split(',').slice(9, 18)[index] == -1"
                    >
                      {{ r1 }}
                    </span>
                    <span
                      class="oneOver"
                      v-else-if="playerData['net_hole_vspars_R' + roundsPlayed].split(',').slice(9, 18)[index] == 1"
                    >
                      {{ r1 }}
                    </span>
                    <span
                      class="twoOver"
                      v-else-if="playerData['net_hole_vspars_R' + roundsPlayed].split(',')[index] == 2"
                    >
                      {{ r1 }}
                    </span>
                    <span v-else>
                      {{ r1 }}
                    </span>
                  </td>
                  <td>{{ inVal(playerData['net_hole_scores_R' + roundsPlayed]) }}</td>
                  <td>{{ totalVal(playerData['net_hole_scores_R' + roundsPlayed])}}</td>
                </tr>
                <tr>
                  <td>
                    <a :href="'/player-profiles/' + playerData.partner_ref_1" target="_blank" class="playerLinkPartner">{{playerData.partner_surname_1}}</a>
                  </td>
                  <td
                    v-for="(r1, index) in playerData['net_hole_scores_partner_1_R' + roundsPlayed].split(',').slice(0, 9)"
                    :key="index + Math.random()"
                  >
                    <span
                      class="twoUnder"
                      v-if="playerData['net_hole_vspars_partner_1_R' + roundsPlayed].split(',')[index] == -2"
                    >
                      {{ r1 }}
                    </span>
                    <span
                      class="oneUnder"
                      v-else-if="playerData['net_hole_vspars_partner_1_R' + roundsPlayed].split(',')[index] == -1"
                    >
                      {{ r1 }}
                    </span>
                    <span
                      class="oneOver"
                      v-else-if="playerData['net_hole_vspars_partner_1_R' + roundsPlayed].split(',')[index] == 1"
                    >
                      {{ r1 }}
                    </span>
                    <span
                      class="
                      "
                      v-else-if="playerData['net_hole_vspars_partner_1_R' + roundsPlayed].split(',')[index] == 2"
                    >
                      {{ r1 }}
                    </span>
                    <span v-else>
                      {{ r1 }}
                    </span>
                  </td>
                  <td>{{ outVal(playerData['net_hole_scores_partner_1_R' + roundsPlayed]) }}</td>
                  <td
                    v-for="(r1, index) in playerData['net_hole_scores_partner_1_R' + roundsPlayed].split(',').slice(9, 18)"
                    :key="index + Math.random()"
                  >
                    <span
                      class="twoUnder"
                      v-if="playerData['net_hole_vspars_partner_1_R' + roundsPlayed].split(',').slice(9, 18)[index] == -2"
                    >
                      {{ r1 }}
                    </span>
                    <span
                      class="oneUnder"
                      v-else-if="playerData['net_hole_vspars_partner_1_R' + roundsPlayed].split(',').slice(9, 18)[index] == -1"
                    >
                      {{ r1 }}
                    </span>
                    <span
                      class="oneOver"
                      v-else-if="playerData['net_hole_vspars_partner_1_R' + roundsPlayed].split(',').slice(9, 18)[index] == 1"
                    >
                      {{ r1 }}
                    </span>
                    <span
                      class="twoOver"
                      v-else-if="playerData['net_hole_vspars_partner_1_R' + roundsPlayed].split(',')[index] == 2"
                    >
                      {{ r1 }}
                    </span>
                    <span v-else>
                      {{ r1 }}
                    </span>
                  </td>
                  <td>{{ inVal(playerData['net_hole_scores_partner_1_R' + roundsPlayed]) }}</td>
                  <td>{{ totalVal(playerData['net_hole_scores_partner_1_R' + roundsPlayed])}}</td>
                </tr>
                <tr>
                  <td>
                    <a :href="'/player-profiles/' + playerData.partner_ref_2" target="_blank" class="playerLinkPartner" >{{playerData.partner_surname_2}}</a>
                  </td>
                  <td
                    v-for="(r1, index) in playerData['net_hole_scores_partner_2_R' + roundsPlayed].split(',').slice(0, 9)"
                    :key="index + Math.random()"
                  >
                    <span
                      class="twoUnder"
                      v-if="playerData['net_hole_vspars_partner_2_R' + roundsPlayed].split(',')[index] == -2"
                    >
                      {{ r1 }}
                    </span>
                    <span
                      class="oneUnder"
                      v-else-if="playerData['net_hole_vspars_partner_2_R' + roundsPlayed].split(',')[index] == -1"
                    >
                      {{ r1 }}
                    </span>
                    <span
                      class="oneOver"
                      v-else-if="playerData['net_hole_vspars_partner_2_R' + roundsPlayed].split(',')[index] == 1"
                    >
                      {{ r1 }}
                    </span>
                    <span
                      class="
                      "
                      v-else-if="playerData['net_hole_vspars_partner_2_R' + roundsPlayed].split(',')[index] == 2"
                    >
                      {{ r1 }}
                    </span>
                    <span v-else>
                      {{ r1 }}
                    </span>
                  </td>
                  <td>{{ outVal(playerData['net_hole_scores_partner_2_R' + roundsPlayed]) }}</td>
                  <td
                    v-for="(r1, index) in playerData['net_hole_scores_partner_2_R' + roundsPlayed].split(',').slice(9, 18)"
                    :key="index + Math.random()"
                  >
                    <span
                      class="twoUnder"
                      v-if="playerData['net_hole_vspars_partner_2_R' + roundsPlayed].split(',').slice(9, 18)[index] == -2"
                    >
                      {{ r1 }}
                    </span>
                    <span
                      class="oneUnder"
                      v-else-if="playerData['net_hole_vspars_partner_2_R' + roundsPlayed].split(',').slice(9, 18)[index] == -1"
                    >
                      {{ r1 }}
                    </span>
                    <span
                      class="oneOver"
                      v-else-if="playerData['net_hole_vspars_partner_2_R' + roundsPlayed].split(',').slice(9, 18)[index] == 1"
                    >
                      {{ r1 }}
                    </span>
                    <span
                      class="twoOver"
                      v-else-if="playerData['net_hole_vspars_partner_2_R' + roundsPlayed].split(',')[index] == 2"
                    >
                      {{ r1 }}
                    </span>
                    <span v-else>
                      {{ r1 }}
                    </span>
                  </td>
                  <td>{{ inVal(playerData['net_hole_scores_partner_2_R' + roundsPlayed]) }}</td>
                  <td>{{ totalVal(playerData['net_hole_scores_partner_2_R' + roundsPlayed])}}</td>
                </tr>
                <tr>
                  <td>
                    <a :href="'/player-profiles/' + playerData.partner_ref_3" target="_blank" class="playerLinkPartner">{{playerData.partner_surname_3}}</a>
                  </td>
                  <td
                    v-for="(r1, index) in playerData['net_hole_scores_partner_3_R' + roundsPlayed].split(',').slice(0, 9)"
                    :key="index + Math.random()"
                  >
                    <span
                      class="twoUnder"
                      v-if="playerData['net_hole_vspars_partner_3_R' + roundsPlayed].split(',')[index] == -2"
                    >
                      {{ r1 }}
                    </span>
                    <span
                      class="oneUnder"
                      v-else-if="playerData['net_hole_vspars_partner_3_R' + roundsPlayed].split(',')[index] == -1"
                    >
                      {{ r1 }}
                    </span>
                    <span
                      class="oneOver"
                      v-else-if="playerData['net_hole_vspars_partner_3_R' + roundsPlayed].split(',')[index] == 1"
                    >
                      {{ r1 }}
                    </span>
                    <span
                      class="
                      "
                      v-else-if="playerData['net_hole_vspars_partner_3_R' + roundsPlayed].split(',')[index] == 2"
                    >
                      {{ r1 }}
                    </span>
                    <span v-else>
                      {{ r1 }}
                    </span>
                  </td>
                  <td>{{ outVal(playerData['net_hole_scores_partner_3_R' + roundsPlayed]) }}</td>
                  <td
                    v-for="(r1, index) in playerData['net_hole_scores_partner_3_R' + roundsPlayed].split(',').slice(9, 18)"
                    :key="index + Math.random()"
                  >
                    <span
                      class="twoUnder"
                      v-if="playerData['net_hole_vspars_partner_3_R' + roundsPlayed].split(',').slice(9, 18)[index] == -2"
                    >
                      {{ r1 }}
                    </span>
                    <span
                      class="oneUnder"
                      v-else-if="playerData['net_hole_vspars_partner_3_R' + roundsPlayed].split(',').slice(9, 18)[index] == -1"
                    >
                      {{ r1 }}
                    </span>
                    <span
                      class="oneOver"
                      v-else-if="playerData['net_hole_vspars_partner_3_R' + roundsPlayed].split(',').slice(9, 18)[index] == 1"
                    >
                      {{ r1 }}
                    </span>
                    <span
                      class="twoOver"
                      v-else-if="playerData['net_hole_vspars_partner_3_R' + roundsPlayed].split(',')[index] == 2"
                    >
                      {{ r1 }}
                    </span>
                    <span v-else>
                      {{ r1 }}
                    </span>
                  </td>
                  <td>{{ inVal(playerData['net_hole_scores_partner_3_R' + roundsPlayed]) }}</td>
                  <td>{{ totalVal(playerData['net_hole_scores_partner_3_R' + roundsPlayed])}}</td>
                </tr>
                <tr class="TeamRow">
                  <td>Team</td>
                  <td
                    v-for="(r1, index) in playerData['team_hole_vspars_R' + roundsPlayed].split(',').slice(0, 9)"
                    :key="index + Math.random()"
                  >
                    <span
                      class="twoUnder"
                      v-if="playerData['team_hole_vspars_R' + roundsPlayed].split(',')[index] == -2"
                    >
                      {{ r1 }}
                    </span>
                    <span
                      class="oneUnder"
                      v-else-if="playerData['team_hole_vspars_R' + roundsPlayed].split(',')[index] == -1"
                    >
                      {{ r1 }}
                    </span>
                    <span
                      class="oneOver"
                      v-else-if="playerData['team_hole_vspars_R' + roundsPlayed].split(',')[index] == 1"
                    >
                      {{ r1 }}
                    </span>
                    <span
                      class="
                      "
                      v-else-if="playerData['team_hole_vspars_R' + roundsPlayed].split(',')[index] == 2"
                    >
                      {{ r1 }}
                    </span>
                    <span v-else>
                      <span v-if="r1 == '0'">Par</span>
                    </span>
                  </td>
                  <td>{{ outVal(playerData['team_hole_vspars_R' + roundsPlayed]) }}</td>
                  <td
                    v-for="(r1, index) in playerData['team_hole_vspars_R' + roundsPlayed].split(',').slice(9, 18)"
                    :key="index + Math.random()"
                  >
                    <span
                      class="twoUnder"
                      v-if="playerData['team_hole_vspars_R' + roundsPlayed].split(',').slice(9, 18)[index] == -2"
                    >
                      {{ r1 }}
                    </span>
                    <span
                      class="oneUnder"
                      v-else-if="playerData['team_hole_vspars_R' + roundsPlayed].split(',').slice(9, 18)[index] == -1"
                    >
                      {{ r1 }}
                    </span>
                    <span
                      class="oneOver"
                      v-else-if="playerData['team_hole_vspars_R' + roundsPlayed].split(',').slice(9, 18)[index] == 1"
                    >
                      {{ r1 }}
                    </span>
                    <span
                      class="twoOver"
                      v-else-if="playerData['team_hole_vspars_R' + roundsPlayed].split(',')[index] == 2"
                    >
                      {{ r1 }}
                    </span>
                    <span v-else>
                      <span v-if="r1 == '0'">Par</span>
                    </span>
                  </td>
                  <td>{{ inVal(playerData['team_hole_vspars_R' + roundsPlayed]) }}</td>
                  <td>{{ totalVal(playerData['team_hole_vspars_R' + roundsPlayed])}}</td>
                </tr>
              </template> -->
              <template>
                <template>
                  <tr class="RoundColour">
                    <!-- <template>
                      <td>R{{ buttonRound }} <span v-if="data.multi_course == 'Y'" :class="playerData['course_colour_R' + buttonRound]">•</span></td>
                    </template> -->
                    <template>
                      <template>
                        <td>{{playerData['sg_drive_R' + buttonRound]}}</td>
                        <td>{{playerData['sg_approach_R' + buttonRound]}}</td>
                        <td>{{playerData['sg_short_R' + buttonRound]}}</td>
                        <td>{{playerData['sg_putting_R' + buttonRound]}}</td>
                        <td>{{playerData['sg_total_R' + buttonRound]}}</td>
                      </template>
                    </template>
                  </tr>
                </template>
              </template>
            </template>
          </tbody>
        </table>
      </template>
  </div>
</template>

<script>
export default {
  name: "playerReportCard",
  props: [
    "data",
    "roundsPlayed",
    "scoreType",
    "team",
    "courses",
    "playerData",
    "playerDataTeam",
    "pointsOn"
  ],
  data() {
    return {
      oneUnder: "oneUnder",
      twoUnder: "twoUnder",
      oneOver: "oneOver",
      twoOver: "twoOver",
      buttonRound: this.roundsPlayed,
      isActive: '',
    };
  },
  computed: {
    scoreOne() {
      var vspar1 = this.data.vspar_R1.split(",");
      var score1 = this.data.score_R1.split(",");
      return { score1, vspar1 };
    },
    scoreTwo() {
      var vspar2 = this.data.vspar_R2.split(",");
      var score2 = this.data.score_R2.split(",");
      return { score2, vspar2 };
    },
    scoreThree() {
      var vspar3 = this.data.vspar_R3.split(",");
      var score3 = this.data.score_R3.split(",");
      return { score3, vspar3 };
    },
    scoreFour() {
      var vspar4 = this.data.vspar_R4.split(",");
      var score4 = this.data.score_R4.split(",");
      return { score4, vspar4 };
    }
  },
  methods: {
    ShowRound(index) {
      console.log("index")
      console.log(index)
      this.buttonRound = this.roundsPlayed
      return this.buttonRound = index +1
    },
    StatoutVal(value, inOut) {
      // var split = value.split(",");
      // var front9 = split.slice(0, 9);
      var full = value.split(',')
      var fullCheck = full.filter((str) => str !== '' && str !== 'N');
      var fullTotal = full.filter((str) => str !== '')
      var front9Full = full.slice(0,9)
      var back9Full = full.slice(9,18)
      var front9Check = front9Full.filter((str) => str !== '' && str !== 'N');
      var frontTotal = front9Full.filter((str) => str !== '')
      var back9Check = back9Full.filter((str) => str !== '' && str !== 'N');
      var backTotal = back9Full.filter((str) => str !== '')
      if(inOut === 'front'){
        var total = front9Check.length + '/' + frontTotal.length
      }
      else if(inOut === 'back'){
        total = back9Check.length + '/' + backTotal.length
      }
      else{
        total = fullCheck.length + '/' + fullTotal.length
      }
      return total;
    },
    outVal(value) {
      var split = value.split(",");
      var front9 = split.slice(0, 9);
      for (var i = 0; i < front9.length; i++) front9[i] = +front9[i];
      var sum = front9.reduce(function(a, b) {
        return a + b;
      }, 0);
      if (sum == 0) {
        return sum = ''
      } else {
        return sum; 
      }
    },
    inVal(value) {
      var split = value.split(",");
      var back9 = split.slice(9, 18);
      for (var i = 0; i < back9.length; i++) back9[i] = +back9[i];
      var sum = back9.reduce(function(a, b) {
        return a + b;
      }, 0);
      if (sum == 0) {
        return sum = ''
      } else {
        return sum; 
      }
    },
    totalVal(value) {
      var split = value.split(",");
      for (var i = 0; i < split.length; i++) split[i] = +split[i];
      var sum = split.reduce(function(a, b) {
        return a + b;
      }, 0);
      if (sum == 0) {
        return sum = ''
      } else {
        return sum; 
      }
    },
    range: function(start, end) {
      if (this.roundsPlayed === 1) return this.roundsPlayed;
      else
        return Array(end - start + 1)
          .fill()
          .map((_, idx) => start + idx);
    },
    getArraySum: function(array, f, t, zeroVal) 
    {
      var result = 0;

      if (Array.isArray(array))
      {
        if (!f) f = 0;
        if (!t) t = (array.length - 1);

        for (var i = f; i <= t; i++)
        {
          var arrVal = array[i];

          if (arrVal != "" && !isNaN(arrVal))
            result += parseInt(arrVal);
        }
      }

      if (result == 0 && typeof zeroVal == "string")
        result = zeroVal;

      return result;
    }
  },
  mounted() {
    this.getArraySum();
  }
};
</script>
